import { GeoUtils } from "./geo-utils";

export function offsetGeneralRoute(data) {

    return GeoUtils.defaultOffsets.map(offset => {
        const offp = (p) => {
            if (!p) return;

            p.lon += offset;
        }

        const result = JSON.parse(JSON.stringify(data));
        offp(result.startPoint);
        offp(result.finishPoint);
        offp(result.startNode?.point);
        offp(result.finishNode?.point);

        if (result.startLink) result.startLink.points.forEach(p => offp(p));
        if (result.finishLink) result.finishLink.points.forEach(p => offp(p));
        if (result.directLink) result.directLink.points.forEach(p => offp(p));

        result.lines.forEach(line => {
            line.points.forEach(p => offp(p));
        });

        result.links.forEach(link => {
            link.points.forEach(p => offp(p));
        });

        if (result.entryPoints) result.entryPoints.forEach(p => offp(p));
        if (result.exitPoints) result.exitPoints.forEach(p => offp(p));

        (result.alternativeRoutes ?? []).forEach(r => {
            offp(r.startNode?.point);
            offp(r.finishNode?.point);

            r.lines.forEach(line => {
                line.points.forEach(p => offp(p));
            });

            r.links.forEach(link => {
                link.points.forEach(p => offp(p));
            });
        });

        return result;
    });
}
